<div class="modal-body">
  <p>{{ message }}</p>

  <div class="text-right">
    <button class="btn btn-cancel mr-2" mat-button (click)="closePopup()">No</button>
    <button class="btn btn-primary" mat-button (click)="deleteRecord()">Yes</button>
  </div>
</div>
